import React, { Component } from 'react'
import './styles.css'
import { apiEmployee } from '../../../services/apiamrg'
import Header from '../../../components/header'
import Rodape from '../../../components/rodape'
import Skeleton from '../../../components/skeleton'
import loader from '../../../classes/loader'
import AddButton from '../../../components/addButton';
import { Link, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import { NOME_EMPRESA } from '../../../config'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt, faPen, faPlus, faChevronDown, faChevronUp, faDollarSign, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'
import Box from '@mui/material/Box'
import { confirmAlert } from 'react-confirm-alert'
import 'react-confirm-alert/src/react-confirm-alert.css'
import moment from 'moment'
import Modal from '@mui/material/Modal'
import { Formik, Field, Form } from 'formik'


const estadoInicial = {
    name: '',
    contas: [],
    pesquisa: "",
    tipoPesquisa: 1,
    pessoas: '',
    deleteConta: false,

    loading: true,
    redirect: false,

    acessos: [],
    permissoes: [],
    acessosPermissoes: [],
    direcaoTabela: faChevronDown,

    load: 100,

    // modal de pagamento
    modalPagamento: false,
    pagChave: 0,
    pagHistorico: '',
    pagSaldo: 0,
    pagValor: '',
    pagDesconto: '',
    pagData: moment().format('YYYY-MM-DD'),
    pagBloqueado: false,

    planosContasOptions: [],
    pagContaContabil: '',
}

class ContasPagar extends Component {

    state = {
        ...estadoInicial,
        usuarioLogado: this.props.user
    }

    componentDidMount = async () => {
        await this.loadAll();

        if (this.state.chaveFocus) {
            if (this.refs.focusMe) {
                await this.refs.focusMe.focus();
            }
        }

        this.state.acessosPermissoes.map((e) => {
            if (e.acessoAcao == "CONTAS_ABERTAS" && e.permissaoConsulta == 0) {
                this.setState({ redirect: true })
            }
        })
    }

    componentDidUpdate = async (prevProps, prevState) => {
        if (this.state.deleteConta && this.state.modalItemAberto != prevState.modalItemAberto) {
            await this.setState({
                modalItemAberto: false,
                deleteConta: false
            })
        }
    }

    loadAll = async () => {
        await this.setState({
            contas: await loader.getBase('getContasPagar.php', this.state.usuarioLogado.empresa),
            acessos: await loader.getBase('getTiposAcessos.php'),
            permissoes: await loader.getBase('getPermissoes.php'),
            planosContasOptions: await loader.getPlanosContasAnaliticasOptions(), // Adicionar esta linha
        })

        this.setState({ contas: this.state.contas.map((conta) => ({ ...conta, Valor: conta.Valor - conta.valorDescontos })) });

        await this.getPessoas();

        if (this.props.location.state && this.props.location.state.chave) {
            await this.setState({ chaveFocus: this.props.location.state.chave });
        }

        await this.setState({
            acessosPermissoes: await loader.testaAcesso(this.state.acessos, this.state.permissoes, this.state.usuarioLogado),
            loading: false
        })
    }

    getPessoas = async () => {
        await apiEmployee.post(`getPessoas.php`, {
            token: true,
        }).then(
            async response => {
                await this.setState({ pessoas: response.data })

                let pessoa = "";
                const contas = this.state.contas.map((e) => {
                    pessoa = this.state.pessoas.find((el) => el.Chave == e.Pessoa);
                    if (pessoa) {
                        return (
                            { ...e, fornecedorNome: pessoa.Nome }
                        )
                    } else {
                        return (
                            { ...e, fornecedorNome: '' }
                        )
                    }
                })

                await this.setState({ contas: contas })

            },
            response => { this.erroApi(response) }
        )
    }

    erroApi = async (res) => {
        alert(res)
        await this.setState({ redirect: true })
    }

    abrirPagamento = (feed) => {
        this.setState({
            modalPagamento: true,
            pagChave: feed.Chave,
            pagHistorico: feed.Historico,
            pagSaldo: feed.SaldoBRL,
            pagSaldoOriginal: feed.Saldo,
            pagValor: '',
            pagDesconto: '',
            pagData: moment().format('YYYY-MM-DD'),
            // Atualize esta linha:
            pagContaContabil: (!feed.Conta_Contabil || feed.Conta_Contabil === "0") ? '' : feed.Conta_Contabil,
            pagBloqueado: false,
        })
    }

    pagarConta = async (validForm) => {
        if (!validForm) return;

        this.setState({ pagBloqueado: true, loading: true });

        const lote = await loader.getLote();
        const valorBRL = parseFloat(this.state.pagValor.replaceAll('.', '').replaceAll(',', '.'));
        const descontoBRL = this.state.pagDesconto ? parseFloat(this.state.pagDesconto.replaceAll('.', '').replaceAll(',', '.')) : 0;

        const roe = this.state.pagSaldoOriginal && this.state.pagSaldoOriginal > 0 
            ? (this.state.pagSaldo / this.state.pagSaldoOriginal) 
            : 1;
        const valorOriginal = valorBRL / roe;
        const descontoOriginal = descontoBRL / roe;

        await apiEmployee.post(`pagarManual.php`, {
            token: true,
            chave: this.state.pagChave,
            values: `'${moment().format('YYYY-MM-DD')}', '${lote}', '0', '${this.state.pagChave}', 'Pagamento efetuado', 3`,
            saldo: this.state.pagSaldoOriginal,
            valor: valorOriginal + descontoOriginal,
            data: moment().format('YYYY-MM-DD'),
            data_pagto: this.state.pagData,
            conta_contabil: this.state.pagContaContabil
        }).then(
            async res => {
                if (res.data[0]) {
                    await loader.salvaLogs('contas_aberto', this.state.usuarioLogado.codigo, null,
                        `Saldo (de)${this.state.pagSaldoOriginal} (para)${this.state.pagSaldoOriginal - (valorOriginal + descontoOriginal)}; Data_Pagto ${this.state.pagData}; Valor_Pago ${valorOriginal + descontoOriginal};`,
                        this.state.pagChave);
                    await this.setState({ modalPagamento: false, loading: false });
                    await this.loadAll();
                } else {
                    alert('Erro ao pagar conta');
                    this.setState({ pagBloqueado: false, loading: false });
                }
            },
            async err => {
                console.log(err);
                this.setState({ pagBloqueado: false, loading: false });
            }
        );
    }

    deleteConta = async (chave, nome) => {
        this.setState({ deleteConta: true })
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className='custom-ui text-center'>
                        <h1>{NOME_EMPRESA}</h1>
                        <p>Deseja remover a conta de {nome}? </p>
                        <button
                            style={{ marginRight: 5 }}
                            className="btn btn-danger w-25"
                            onClick={
                                async () => {
                                    onClose()
                                }
                            }
                        >
                            Não
                        </button>
                        <button
                            style={{ marginRight: 5 }}
                            className="btn btn-success w-25"
                            onClick={
                                async () => {
                                    await apiEmployee.post(`deleteConta.php`, {
                                        token: true,
                                        chave: chave
                                    }).then(
                                        async response => {
                                            if (response.data == true) {
                                                await loader.salvaLogs('contas_aberto', this.state.usuarioLogado.codigo, null, "Exclusão", chave);

                                                document.location.reload()
                                            }
                                        },
                                        async response => {
                                            this.erroApi(response)
                                        }
                                    )
                                    onClose()
                                }
                            }

                        >
                            Sim
                        </button>
                    </div>
                )
            }
        })
    }

    reverterItens = async () => {
        await this.setState({ loading: true })
        const contas = this.state.contas.reverse();

        if (this.state.direcaoTabela == faChevronDown) {
            await this.setState({ direcaoTabela: faChevronUp });
        } else {
            await this.setState({ direcaoTabela: faChevronDown });
        }

        await this.setState({ contas, loading: false });
    }

    filtrarPesquisa = (conta) => {
        const pesquisa = this.state.pesquisa.toLowerCase();

        if (this.state.tipoPesquisa == 1) {
            const pessoa = conta.fornecedorNome ? String(conta.fornecedorNome).toLowerCase() : '';
            return pessoa.includes(pesquisa);
        } else if (this.state.tipoPesquisa == 2) {
            const valor = conta.Valor ? String(conta.Valor).toLowerCase() : '';
            return valor.includes(pesquisa);
        } else if (this.state.tipoPesquisa == 3) {
            const chave = conta.Chave ? String(conta.Chave).toLowerCase() : '';
            return chave.includes(pesquisa);
        } else if (this.state.tipoPesquisa == 4) {
            const data = conta.Vencimento ? moment(conta.Vencimento).format('DD/MM/YYYY').toLowerCase() : '';
            return data.includes(pesquisa);
        }

        return true;
    }



    render() {

        return (

            <div className='allContent'>

                <div>
                    {this.state.loading &&
                        <Skeleton />
                    }

                    {this.state.redirect &&
                        <Redirect to={'/'} />
                    }

                    {!this.state.loading &&
                        <div>
                            <section>
                                <Header voltarContasAbertas titulo="Contas a Pagar" />

                                <Modal
                                    style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-start', paddingTop: '5vh', overflow: 'auto' }}
                                    open={this.state.modalPagamento}
                                    onClose={() => this.setState({ modalPagamento: false })}
                                >
                                    <Box sx={{
                                        background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
                                        padding: '30px',
                                        borderRadius: '12px',
                                        minWidth: 350,
                                        maxWidth: 500,
                                        width: '90%',
                                        boxShadow: '0 10px 40px rgba(0,0,0,0.15)',
                                        border: '1px solid rgba(0,0,0,0.08)'
                                    }}>
                                        <h5 style={{ marginBottom: '8px', color: '#333', fontWeight: 600 }}>Pagar: {this.state.pagHistorico}</h5>
                                        <p style={{ marginBottom: '20px', color: '#666', fontSize: '0.95rem' }}>Saldo: <span style={{ fontWeight: 600, color: '#28a745' }}>R$ {new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(this.state.pagSaldo)}</span></p>
                                        {(() => {
                                            const valor = parseFloat((this.state.pagValor || '0').replaceAll('.', '').replaceAll(',', '.'));
                                            const desconto = parseFloat((this.state.pagDesconto || '0').replaceAll('.', '').replaceAll(',', '.'));
                                            const validPag = [
                                                valor > 0,
                                                !isNaN(desconto),
                                                (valor + desconto).toFixed(2) === parseFloat(this.state.pagSaldo).toFixed(2), // deve ser igual ao saldo
                                                this.state.pagData,
                                                this.state.pagContaContabil !== '',
                                                !this.state.pagBloqueado,
                                            ].reduce((t, a) => t && a);
                                            return (
                                                <Formik initialValues={{}} onSubmit={async () => { await this.pagarConta(validPag); }}>
                                                    <Form>
                                                        <div className="row" style={{ marginBottom: 15, alignItems: 'center' }}>
                                                            <div className="col-3"><label style={{ marginBottom: 0, fontWeight: 500 }}>Valor</label></div>
                                                            <div className="col-1" style={{ textAlign: 'center' }}>
                                                                {this.state.pagValor && (isNaN(valor) || valor <= 0 || (valor + desconto).toFixed(2) !== parseFloat(this.state.pagSaldo).toFixed(2)) &&
                                                                    <FontAwesomeIcon title='Valor deve ser igual ao saldo' icon={faExclamationTriangle} color='#ff9800' />}
                                                            </div>
                                                            <div className="col-8" style={{ display: 'flex', gap: '2px', alignItems: 'center' }}>
                                                                <Field className="form-control text-right" type="text" placeholder="0,00" value={this.state.pagValor}
                                                                    style={{ flex: 1 }}
                                                                    onClick={e => e.target.select()}
                                                                    onChange={e => this.setState({ pagValor: e.currentTarget.value })}
                                                                    onBlur={e => this.setState({ pagValor: Number(e.currentTarget.value.replaceAll('.', '').replaceAll(',', '.')) ? new Intl.NumberFormat('pt-BR').format(e.currentTarget.value.replaceAll('.', '').replaceAll(',', '.')) : '' })} />
                                                                <button
                                                                    type="button"
                                                                    onClick={() => this.setState({ pagValor: new Intl.NumberFormat('pt-BR').format(this.state.pagSaldo) })}
                                                                    title="Preencher com o saldo"
                                                                    style={{
                                                                        padding: '2px 6px',
                                                                        background: 'transparent',
                                                                        border: 'none',
                                                                        color: '#6c757d',
                                                                        cursor: 'pointer',
                                                                        fontSize: '0.68rem',
                                                                        transition: 'color 0.2s',
                                                                        whiteSpace: 'nowrap',
                                                                        textDecoration: 'none'
                                                                    }}
                                                                    onMouseEnter={e => e.target.style.color = '#495057'}
                                                                    onMouseLeave={e => e.target.style.color = '#6c757d'}
                                                                >
                                                                    Pagar tudo
                                                                </button>
                                                            </div>
                                                        </div>

                                                        <div className="row" style={{ marginBottom: 15 }}>
                                                            <div className="col-3"><label style={{ marginBottom: 0, fontWeight: 500 }}>Juros/Desconto</label></div>
                                                            <div className="col-1"></div>
                                                            <div className="col-8">
                                                                <Field className="form-control text-right" type="text" placeholder="0,00" value={this.state.pagDesconto}
                                                                    onClick={e => e.target.select()}
                                                                    onChange={e => this.setState({ pagDesconto: e.currentTarget.value })}
                                                                    onBlur={e => this.setState({ pagDesconto: Number(e.currentTarget.value.replaceAll('.', '').replaceAll(',', '.')) ? new Intl.NumberFormat('pt-BR').format(e.currentTarget.value.replaceAll('.', '').replaceAll(',', '.')) : '' })} />
                                                            </div>
                                                        </div>


                                                        <div className="row" style={{ marginBottom: 15 }}>
                                                            <div className="col-3"><label style={{ marginBottom: 0, fontWeight: 500 }}>Conta Contábil</label></div>
                                                            <div className="col-1" style={{ textAlign: 'center' }}>
                                                                {!this.state.pagContaContabil && <FontAwesomeIcon title='Selecione uma conta' icon={faExclamationTriangle} color='#ff9800' />}
                                                            </div>
                                                            <div className="col-8">
                                                                <select
                                                                    className="form-control"
                                                                    value={this.state.pagContaContabil}
                                                                    onChange={e => this.setState({ pagContaContabil: e.currentTarget.value })}
                                                                >
                                                                    <option value="">Selecione uma conta...</option>
                                                                    {this.state.planosContasOptions.map((opcao, index) => (
                                                                        <option key={index} value={opcao.value}>
                                                                            {opcao.label}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                        </div>


                                                        <div className="row" style={{ marginBottom: 25 }}>
                                                            <div className="col-3"><label style={{ marginBottom: 0, fontWeight: 500 }}>Data Pagamento</label></div>
                                                            <div className="col-1" style={{ textAlign: 'center' }}>
                                                                {!this.state.pagData && <FontAwesomeIcon title='Preencha a data' icon={faExclamationTriangle} color='#ff9800' />}
                                                            </div>
                                                            <div className="col-8">
                                                                <Field className="form-control" type="date" value={this.state.pagData}
                                                                    onChange={e => this.setState({ pagData: e.currentTarget.value })} />
                                                            </div>
                                                        </div>
                                                        <div style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
                                                            <button
                                                                type="submit"
                                                                className={validPag ? 'btn btn-success' : 'btn btn-success'}
                                                                disabled={!validPag}
                                                                style={validPag ? { width: 150 } : { width: 150, opacity: 0.5, cursor: 'not-allowed' }}
                                                            >
                                                                Pagar
                                                            </button>
                                                            <button
                                                                type="button"
                                                                onClick={() => this.setState({ modalPagamento: false })}
                                                                style={{
                                                                    width: 150,
                                                                    padding: '10px 20px',
                                                                    background: '#6c757d',
                                                                    color: '#fff',
                                                                    border: 'none',
                                                                    borderRadius: '6px',
                                                                    fontWeight: 600,
                                                                    fontSize: '0.95rem',
                                                                    cursor: 'pointer',
                                                                    transition: 'all 0.3s',
                                                                    boxShadow: '0 4px 12px rgba(108, 117, 125, 0.2)'
                                                                }}
                                                                onMouseEnter={(e) => {
                                                                    e.target.style.background = '#5a6268';
                                                                    e.target.style.boxShadow = '0 6px 16px rgba(108, 117, 125, 0.3)';
                                                                    e.target.style.transform = 'translateY(-2px)';
                                                                }}
                                                                onMouseLeave={(e) => {
                                                                    e.target.style.background = '#6c757d';
                                                                    e.target.style.boxShadow = '0 4px 12px rgba(108, 117, 125, 0.2)';
                                                                    e.target.style.transform = 'translateY(0)';
                                                                }}
                                                            >
                                                                Cancelar
                                                            </button>
                                                        </div>
                                                    </Form>
                                                </Formik>
                                            );
                                        })()}
                                    </Box>
                                </Modal>


                                <br />
                            </section>

                            <div className="row">
                                <div className="col-2"></div>
                                <div className="col-2"></div>
                            </div>

                            <div className="col-12 text-left">
                                <div className="row mobileajuster3">
                                    <div className="col-1 sumir">
                                    </div>

                                    <div className="col-12 text-right pesquisa mobileajuster1 ">
                                        <div className="col-12  text-right pesquisa mobileajuster1 ">
                                            <select className="form-control tipoPesquisa col-4 col-sm-4 col-md-3 col-lg-3 col-xl-2" placeholder="Tipo de pesquisa..." value={this.state.tipoPesquisa} onChange={e => { this.setState({ tipoPesquisa: e.currentTarget.value }) }}>
                                                <option value={1}>Pessoa</option>
                                                <option value={2}>Valor</option>
                                                <option value={4}>Vencimento</option>
                                                <option value={3}>Chave</option>
                                            </select>
                                            <input className="form-control campoPesquisa col-7 col-sm-6 col-md-6 col-lg-5 col-xl-5" placeholder="Pesquise aqui..." value={this.state.pesquisa} onChange={e => { this.setState({ pesquisa: e.currentTarget.value }) }} />
                                            <div>
                                                <Link to={{ pathname: `/financeiro/relatorio`, state: { backTo: 'contasPagar' } }}><button className="btn btn-success">Relatorio</button></Link>
                                            </div>
                                            <div style={{ marginLeft: 15 }}>
                                                <Link to={{
                                                    pathname: `/financeiro/addconta/0`,
                                                    state: { conta: {}, tipo: 1, to: 'contaspagar' }
                                                }}><button className="btn btn-success">+</button></Link>
                                            </div>

                                        </div>
                                    </div>

                                    <div className="col-0 col-sm-0 col-md-3 col-lg-3 col-xl-3"></div>
                                    <div>
                                    </div>

                                </div>
                            </div>

                            <div className="row deleteMargin" id="product-list">
                                <div className="col-xl-2 col-lg-2 col-md-2 col-sm-1 col-0"></div>
                                <div className="col-lg-8 col-md-8 col-sm-12 col-12 mix all dresses bags">
                                    <div className="single-product-item" >
                                        <div className="row subtitulosTabela">
                                            <div className="col-1 text-left">
                                                <span className="subtituloships">Id</span>
                                            </div>
                                            <div className="col-3 text-left">
                                                <span className="subtituloships">Pessoa</span>
                                            </div>
                                            <div className="col-2 text-left">
                                                <span className="subtituloships">Vencimento</span>
                                            </div>
                                            <div className="col-2 text-left">
                                                <span className="subtituloships">Valor</span>
                                            </div>
                                            <div className="col-2 text-left">
                                                <span className="subtituloships">Saldo</span>
                                            </div>
                                            <div className="col-2 text-center revertItem" onClick={() => { if (this.state.contas[0]) { this.reverterItens() } }}>
                                                {this.state.contas[0] &&
                                                    <span className="subtituloships"><FontAwesomeIcon icon={this.state.direcaoTabela} /></span>

                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-2 col-lg-2 col-md-2 col-sm-1 col-0"></div>
                            </div>

                            <AddButton addLink={{
                                pathname: `/financeiro/addconta/0`,
                                state: { conta: {}, tipo: 1, to: 'contaspagar' }
                            }} />

                            <div id="product-list">
                                {this.state.contas[0] != undefined && this.state.contas.filter(this.filtrarPesquisa).splice(0, this.state.load).map((feed, index) => (
                                    <div key={feed.Chave} className="row row-list">
                                        {console.log(feed)}
                                        <div className="col-xl-2 col-lg-2 col-md-2 col-sm-1 col-0"></div>
                                        <div ref={feed.Chave == this.state.chaveFocus ? "focusMe" : ""} tabindex={-1} className={`col-lg-8 col-md-8 col-sm-12 mix all dresses bags ${index % 2 == 0 ? feed.Chave == this.state.chaveFocus ? "par focusLight" : "par " : feed.Chave == this.state.chaveFocus ? "impar focusDark" : "impar"}`}>
                                            <div className="row deleteMargin alignCenter">
                                                <div className=" col-1 text-left" style={{ overflowWrap: 'anywhere' }}>
                                                    <p>{feed.Chave}</p>
                                                </div>
                                                <div className="col-3 text-left">
                                                    <p>{feed.fornecedorNome}</p>
                                                </div>
                                                <div className="col-2 text-left">
                                                    <p>{moment(feed.Vencimento).format('DD/MM/YYYY')}</p>
                                                </div>
                                                <div style={{ overflowWrap: 'anywhere' }} className="col-2 text-left">
                                                    <p>R$ {new Intl.NumberFormat('pt-BR', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(feed.ValorBRL)}</p>
                                                </div>
                                                <div style={{ overflowWrap: 'anywhere' }} className="col-2 text-left">
                                                    <p>R$ {new Intl.NumberFormat('pt-BR', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(feed.SaldoBRL)}</p>
                                                </div>
                                                <div className="col-2  text-left  mobileajuster4 icones">
                                                    <div className='iconelixo giveMargin' type='button' >
                                                        <Link to=
                                                            {{
                                                                pathname: `/financeiro/addconta/0`,
                                                                state: { conta: {}, tipo: 1, to: 'contaspagar' }
                                                            }}
                                                        >
                                                            <FontAwesomeIcon icon={faPlus} />
                                                        </Link>
                                                    </div>


                                                    <div className='iconelixo giveMargin' type='button' >
                                                        <Link to=
                                                            {{
                                                                pathname: `/financeiro/addconta/${feed.Chave}`,
                                                                state: { conta: { ...feed }, to: 'contaspagar' }
                                                            }}
                                                        >
                                                            <FontAwesomeIcon icon={faPen} />
                                                        </Link>
                                                    </div>

                                                    <div className='iconelixo giveMargin' type='button' title='Pagar conta' onClick={() => this.abrirPagamento(feed)}>
                                                        <FontAwesomeIcon icon={faDollarSign} />
                                                    </div>

                                                    {this.state.acessosPermissoes.filter((e) => { if (e.acessoAcao == 'CONTAS_ABERTAS') { return e } }).map((e) => e.permissaoDeleta)[0] == 1 &&
                                                        <div type='button' className='iconelixo' onClick={(a) => this.deleteConta(feed.Chave, feed.fornecedorNome)} >
                                                            <FontAwesomeIcon icon={faTrashAlt} />
                                                        </div>
                                                    }
                                                </div>

                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-2 col-sm-0 col-0"></div>
                                    </div>
                                ))}
                                {this.state.contas.filter(this.filtrarPesquisa)[this.state.load] &&
                                    <div className='loadMoreDiv'>
                                        <div className='loadMore' onClick={() => { this.setState({ load: this.state.load + 100 }) }}>Carregar Mais...</div>
                                    </div>
                                }
                                <br />
                            </div>
                        </div>
                    }
                </div>
                <Rodape />
            </div>
        )

    }
}

const mapStateToProps = ({ user, servidor }) => {
    return {
        user: user,
        online: servidor.online
    }
}

export default connect(mapStateToProps, null)(ContasPagar)